import gql from 'graphql-tag';
import { card } from '@shared/api/fragments/card';
import { short } from '@shared/api/fragments/user';

export const activityFeedItem = gql`
  fragment ActivityFeedItem on ActivityFeedItem {
    id
    channelId
    user {
      ...ShortUser
    }
    eventType
    createdAt
    card {
      ...Card
    }
    count
  }

  ${short}
  ${card}
`;
